// MODULES
import React from "react";
import PropTypes from "prop-types";

// CLASSES
import Session from "@classes/Session";

// COMPONENTS
// HELPERS
import fulfillmentCheck from "./Withdrawal.fulfillment";
import DefaultFields from "../../../components/DefaultFields/DefaultFields";
import {createClassName} from "../../../../../helpers/utils";
import api from "../../../../../helpers/api";
import ActivityIndicator from "../../../../../components/ActivityIndicator/ActivityIndicator";
import i18n from "../../../../../helpers/i18n";
import OptionsList from "../../../components/OptionsList/OptionsList";
import TextView from "../../../../../components/TextView/TextView";
import EditableField from "../../../components/EditableField/EditableField";
import * as CobHelpers from "../../../Cob.helpers";
import Select from "../../../../../components/Select/Select";
import NumberField from "../../../components/NumberField/NumberField";
import TextField from "../../../../../components/TextField/TextField";

export default class Withdrawal extends React.PureComponent
{
    static propTypes = {
        id: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        session: PropTypes.instanceOf(Session).isRequired,
        sectionNumber: PropTypes.number.isRequired,
        number: PropTypes.number.isRequired,
        prevState: PropTypes.object,
        onChange: PropTypes.func.isRequired
    };

    static companyExclusive = false;
    static privateExclusive = false;
    static fields = _getFields();

    withdrawalReasons = [
        {label: "Flytt till annat institut", value: "Flytt till annat institut"},
        {label: "Pension ska betalas ut", value: "Pension ska betalas ut"},
        {label: "Kapitalbehov", value: "Kapitalbehov"},
        {label: "Annat", value: "Annat"}
    ];

    kapitalbehovOptions = [
        {label: "Bostadsköp", value: "Bostadsköp"},
        {label: "Fordonsköp", value: "Fordonsköp"},
        {label: "Betala lån/skulder", value: "Betala lån/skulder"},
        {label: "Resor", value: "Resor"},
        {label: "Dagligt leverne", value: "Dagligt leverne"},
        {label: "Reparation av fordon/bostad", value: "Reparation av fordon/bostad"},
        {label: "Sjukdomsfall", value: "Sjukdomsfall"},
        {label: "Förskott på arv", value: "Förskott på arv"}
    ];

    state = _getInitialState.call(this);

    componentDidUpdate(prevProps, prevState)
    {
        const {props, state} = this;
        const {id, onChange} = props;

        if (prevState.fields !== state.fields)
        {
            onChange(id, {...state}, fulfillmentCheck(props, state));
        }
    }

    async componentDidMount()
    {
        try
        {
            console.log("Loading customer accounts...");
            this.setState({accountsLoading: true}, async () =>
            {
                const newStateProps = {...this.state};
                let accounts = await api("/kundportal/accounts", {
                    identityNo: this.props.session._context.customer.id
                });
                newStateProps.fields.accounts = {options: []};
                newStateProps.fields.accounts.options = [];
                newStateProps.noAccounts = !(accounts && accounts.result && accounts.result.length > 0);
                if (!newStateProps.noAccounts)
                {
                    for (let i = 0; i < accounts.result.length; i++)
                    {
                        const acc = accounts.result[i];
                        newStateProps.fields.accounts.options.push({
                            value: acc.AccountNo,
                            label: "(" + acc.AccountNo + ") " + acc.AccountName,
                            placement: acc.AccountName,
                            checked: false
                        });
                    }
                    newStateProps.fields.accounts.options.push({
                        value: "-",
                        label: "Annan depå/förvaltning",
                        placement: "",
                        checked: false
                    });
                }

                newStateProps.accountsLoading = false;
                this.setState(newStateProps);
            });
        }
        catch (e)
        {
            console.log(e);
        }
    }

    render()
    {
        const {props, state} = this;
        const {title} = props;

        const classes = createClassName("Cob-CustomerInformation", {
            "Cob-View": true,
            "fulfilled": state.isFulfilled
        });

        if (state.accountsLoading)
        {
            return (
                <div className={classes}>
                    <div className="Cob-loading">
                        <ActivityIndicator />
                        <p>{i18n("general", "please_wait")}</p>
                    </div>
                </div>
            );
        }

        const today = new Date();
        let month = (today.getMonth() + 1);
        if (month < 10)
        {
            month = "0" + month;
        }
        let day = today.getDate();
        if (day < 10)
        {
            day = "0" + day;
        }
        let date = today.getFullYear() + "-" + month + "-" + day;

        let withdrawalReason = state.fields.customer_withdrawal_reason_option;

        if (withdrawalReason === "Kapitalbehov")
        {
            withdrawalReason += ": " + state.fields.customer_withdrawal_reason_kapitalbehov;
        }
        else if (withdrawalReason === "Flytt till annat institut" && state.fields.customer_withdrawal_reason_institut.length > 0)
        {
            withdrawalReason += ": " + state.fields.customer_withdrawal_reason_institut;
        }
        else if (withdrawalReason === "Annat")
        {
            withdrawalReason = state.fields.customer_withdrawal_reason;
        }

        let accountNumbersText = "";
        let accountPlacementsText = "";
        let isAccountOtherChecked = false;
        if (state.fields.accounts.options.length > 0)
        {
            for (let i = 0; i < state.fields.accounts.options.length; i++)
            {
                const opt = state.fields.accounts.options[i];
                if (opt.checked)
                {
                    accountNumbersText += (accountNumbersText.length > 0 ? ", " : "");
                    accountPlacementsText += (accountPlacementsText.length > 0 ? ", " : "");
                    if (opt.value === "-")
                    {
                        isAccountOtherChecked = true;
                        accountNumbersText += state.fields.customer_account_other_number;
                        accountPlacementsText += state.fields.customer_account_other_placement;
                    }
                    else
                    {
                        accountNumbersText += opt.value;
                        accountPlacementsText += opt.placement;
                    }
                }
            }
        }

        return (
            <div className={classes}>
                <DefaultFields fields={this.constructor.fields} />

                <input type="hidden" name="customer_city_date" value={date} />
                <input type="hidden" name="advisor_city_date" value={date} />
                <input type="hidden" name="customer_account_number" value={accountNumbersText} />
                <input type="hidden" name="customer_placement_name" value={accountPlacementsText} />

                <div className="Cob-Fields">
                    <h2 className="with-text" style={{marginBottom: "20px"}}>{title}</h2>

                    <OptionsList
                        type="radio"
                        orientation="horizontal"
                        name="selected_type"
                        options={state.fields.selected_type.options}
                        onChange={this._onOptionsListChange}
                    />

                    {state.fields.selected_type.options[0].checked && (
                        <React.Fragment>
                            <p style={{marginTop: "20px"}}>
                                Då du säger upp hela ditt diskretionära mandat hos Fair Investments Sweden AB är det viktigt att ta i
                                beaktan:
                            </p>
                            <ul className={"classic"}>
                                <li>
                                    Det diskretionära mandatet fortlöper kvartalet ut och uppsägning av avtalet måste ske enligt villkoren
                                    i det diskretionära avtalet som har ingåtts med Fair Investments.
                                </li>
                                <li>
                                    När din diskretionära förvaltning avslutas kommer Fair Investments att ta ut avgifter enligt avtalet om
                                    diskretionär förvaltning.
                                </li>
                            </ul>
                        </React.Fragment>
                    )}

                    {state.fields.selected_type.options[1].checked && (
                        <React.Fragment>
                            <p style={{marginTop: "20px"}}>
                                Då du säger upp delar av ditt diskretionära mandat hos Fair Investments Sweden AB är det viktigt att ta i
                                beaktan:
                            </p>
                            <ul className={"classic"}>
                                <li>
                                    Det diskretionära mandatet fortlöper kvartalet ut och uppsägning av avtalet måste ske enligt villkoren
                                    i det diskretionära avtalet som har ingåtts med Fair Investments.
                                </li>
                                <li>
                                    När din diskretionära förvaltning avslutas kommer Fair Investments att ta ut avgifter enligt avtalet om
                                    diskretionär förvaltning.
                                </li>
                            </ul>
                        </React.Fragment>
                    )}

                    {(state.fields.selected_type.options[0].checked || state.fields.selected_type.options[1].checked) && (
                        <React.Fragment>

                            <h3 style={{marginTop: "20px", marginBottom: "10px"}}>Välj depå / förvaltning</h3>

                            {state.fields.accounts.options.length > 0 && (
                                <div>
                                    <OptionsList
                                        type="checkbox"
                                        orientation="vertical"
                                        name="accounts"
                                        options={state.fields.accounts.options}
                                        onChange={this._onOptionsListChange}
                                    />
                                </div>
                            )}

                            {isAccountOtherChecked && (
                                <div style={{width: "100%", alignItems: "flex-start"}}>
                                    <p>
                                        Ange depånummer:
                                    </p>
                                    <EditableField
                                        name="customer_account_other_number"
                                        label={"Depånummer"}
                                        value={state.fields.customer_account_other_number}
                                        valid={
                                            state.fields.customer_account_other_number.length > 0 ? true : ""
                                        }
                                        onChange={this._onFieldChange}
                                        onBlur={this._onFieldBlur}
                                    />

                                    <p>
                                        Namn på förvaltning:
                                    </p>
                                    <EditableField
                                        name="customer_account_other_placement"
                                        label={"Förvaltning"}
                                        value={state.fields.customer_account_other_placement}
                                        valid={
                                            state.fields.customer_account_other_placement.length > 0 ? true : ""
                                        }
                                        onChange={this._onFieldChange}
                                        onBlur={this._onFieldBlur}
                                    />
                                </div>
                            )}

                            {state.fields.accounts.options.length === 0 && (
                                <div style={{width: "100%", alignItems: "flex-start"}}>
                                    <p>
                                        Ange samtliga depånummer:
                                    </p>
                                    <EditableField
                                        name="customer_account_number"
                                        label={"Depånummer"}
                                        value={state.fields.customer_account_number}
                                        valid={
                                            state.fields.customer_account_number.length > 0 ? true : ""
                                        }
                                        onChange={this._onFieldChange}
                                        onBlur={this._onFieldBlur}
                                        required
                                    />

                                    <p>
                                        Namn på förvaltning / förvaltningar:
                                    </p>
                                    <EditableField
                                        name="customer_placement_name"
                                        label={"Förvaltningar"}
                                        value={state.fields.customer_placement_name}
                                        valid={
                                            state.fields.customer_placement_name.length > 0 ? true : ""
                                        }
                                        onChange={this._onFieldChange}
                                        onBlur={this._onFieldBlur}
                                        required
                                    />
                                </div>
                            )}

                            {state.fields.selected_type.options[0].checked && (
                                <p style={{marginTop: "30px"}}>
                                    Ange varför du valt att avsluta förvaltningen.
                                </p>
                            )}

                            {state.fields.selected_type.options[1].checked && (
                                <p style={{marginTop: "30px"}}>
                                    Ange varför du valt att göra ett uttag.
                                </p>
                            )}

                            <Select
                                name="customer_withdrawal_reason_option"
                                label="Anledning"
                                style={{width: "45%", marginRight: "10px"}}
                                options={this.withdrawalReasons}
                                selectedIndex={this.withdrawalReasons.map(c => c.value).indexOf(state.fields.customer_withdrawal_reason_option)}
                                onChange={(option) =>
                                {
                                    CobHelpers.onViewFieldChange.call(this, "customer_withdrawal_reason_option", option.value, false, () =>
                                        fulfillmentCheck(this.props, this.state)
                                    );
                                }}
                            />

                            {state.fields.customer_withdrawal_reason_option === "Flytt till annat institut" && (
                                <React.Fragment>
                                    <p>
                                        Ange institut (valfritt):
                                    </p>

                                    <EditableField
                                        name="customer_withdrawal_reason_institut"
                                        label={"Ange"}
                                        value={state.fields.customer_withdrawal_reason_institut}
                                        valid={true}
                                        onChange={this._onFieldChange}
                                        onBlur={this._onFieldBlur}
                                    />
                                </React.Fragment>
                            )}

                            {state.fields.customer_withdrawal_reason_option === "Kapitalbehov" && (
                                <React.Fragment>
                                    <p>
                                        Specificera kapitalbehov:
                                    </p>

                                    <Select
                                        name="customer_withdrawal_reason_kapitalbehov"
                                        label="Ange"
                                        style={{width: "45%", marginRight: "10px"}}
                                        options={this.kapitalbehovOptions}
                                        selectedIndex={this.kapitalbehovOptions.map(c => c.value).indexOf(state.fields.customer_withdrawal_reason_kapitalbehov)}
                                        onChange={(option) =>
                                        {
                                            CobHelpers.onViewFieldChange.call(this, "customer_withdrawal_reason_kapitalbehov", option.value, false, () =>
                                                fulfillmentCheck(this.props, this.state)
                                            );
                                        }}
                                    />
                                </React.Fragment>
                            )}

                            {state.fields.customer_withdrawal_reason_option === "Annat" && (
                                <React.Fragment>
                                    <p>
                                        Ange annan anledning:
                                    </p>
                                    <EditableField
                                        name="customer_withdrawal_reason"
                                        Component={TextView}
                                        label={`${220 - state.fields.customer_withdrawal_reason.length} tecken kvar`}
                                        value={state.fields.customer_withdrawal_reason}
                                        maxLength={220}
                                        valid={
                                            state.fields.customer_withdrawal_reason.length > 0 &&
                                            state.fields.customer_withdrawal_reason.length <= 220 ? true : ""
                                        }
                                        resize="vertical"
                                        fullWidth
                                        onChange={this._onFieldChange}
                                        onBlur={this._onFieldBlur}
                                        style={{maxHeight: "100px"}}
                                    />
                                </React.Fragment>
                            )}

                            <input type={"hidden"} name={"customer_withdrawal_reason"} value={withdrawalReason} />

                            <h3 style={{marginTop: "30px", marginBottom: "10px"}}>Välj en åtgärd</h3>
                        </React.Fragment>
                    )}

                    {state.fields.selected_type.options[0].checked && (
                        <React.Fragment>
                            <OptionsList
                                type="radio"
                                orientation="vertical"
                                name="radio_action"
                                options={state.fields.radio_action.options}
                                onChange={this._onOptionsListChange}
                            />

                            {state.fields.radio_action.options[1].checked && (
                                <React.Fragment>
                                    <p style={{marginTop: "30px"}}>
                                        Ange depå hos Fair:
                                    </p>
                                    <EditableField
                                        name="move_all_account"
                                        label={"Depånummer"}
                                        value={state.fields.move_all_account}
                                        valid={
                                            state.fields.move_all_account.length > 0 ? true : ""
                                        }
                                        onChange={this._onFieldChange}
                                        onBlur={this._onFieldBlur}
                                    />
                                </React.Fragment>
                            )}
                        </React.Fragment>
                    )}

                    {state.fields.selected_type.options[1].checked && (
                        <React.Fragment>
                            <OptionsList
                                type="radio"
                                orientation="vertical"
                                name="radio_action_withdraw"
                                options={state.fields.radio_action_withdraw.options}
                                onChange={this._onOptionsListChange}
                            />

                            <input type={"hidden"} name="radio_action" value={state.fields.radio_action_withdraw.options[0].checked ? "x" : "w"} />

                            {state.fields.radio_action_withdraw.options[0].checked && (
                                <React.Fragment>
                                    <p style={{marginTop: "30px"}}>
                                        Ange belopp:
                                    </p>
                                    <EditableField
                                        name="move_some_amount"
                                        Component={NumberField}
                                        label={"Ange"}
                                        value={state.fields.move_some_amount}
                                        valid={
                                            state.fields.move_some_amount.length > 0 ? true : ""
                                        }
                                        onChange={this._onFieldChange}
                                        onBlur={this._onFieldBlur}
                                        unit={"kr"}
                                    />
                                    <p>
                                        Ange depå hos Fair:
                                    </p>
                                    <EditableField
                                        name="move_some_account"
                                        label={"Depånummer"}
                                        value={state.fields.move_some_account}
                                        valid={
                                            state.fields.move_some_account.length > 0 ? true : ""
                                        }
                                        onChange={this._onFieldChange}
                                        onBlur={this._onFieldBlur}
                                        required
                                    />
                                </React.Fragment>
                            )}

                            {state.fields.radio_action_withdraw.options[1].checked && (
                                <React.Fragment>
                                    <p style={{marginTop: "30px"}}>
                                        Ange belopp:
                                    </p>
                                    <EditableField
                                        name="withdraw_some_amount"
                                        Component={NumberField}
                                        label={"Ange"}
                                        value={state.fields.withdraw_some_amount}
                                        valid={
                                            state.fields.withdraw_some_amount.length > 0 ? true : ""
                                        }
                                        onChange={this._onFieldChange}
                                        onBlur={this._onFieldBlur}
                                        required
                                        unit={"kr"}
                                    />
                                </React.Fragment>
                            )}
                        </React.Fragment>
                    )}

                    {(state.fields.selected_type.options[0].checked || state.fields.selected_type.options[1].checked) && (
                        <React.Fragment>
                            <h3 style={{marginTop: "30px", marginBottom: "0"}}>Uttagsavgift</h3>
                            <p>
                                Bolaget har rätt till en uttagsavgift som motsvarar en andel av det uttagna beloppet för de situationer där
                                kunden säger upp avtalet eller vill göra uttag från depån. Denna andel uppgår till 5% under första året,
                                4% under andra året, 3% under tredje året, 2% under fjärde året, 1% under femte året och 0% efter 5 år.
                            </p>
                            <OptionsList
                                type="radio"
                                orientation="horizontal"
                                name="has_withdrawal_fee"
                                description={"Tillämpa uttagsavgift i det här fallet?"}
                                options={state.fields.has_withdrawal_fee.options}
                                onChange={this._onOptionsListChange}
                            />

                            {state.fields.has_withdrawal_fee.options[0].checked && (
                                <input type={"hidden"} name="withdrawal_fee" value={"Nej"} />
                            )}

                            {state.fields.has_withdrawal_fee.options[1].checked && (
                                <div style={{display: "block", width: "160px", marginTop: "20px"}}>
                                    <EditableField
                                        name="withdrawal_fee"
                                        Component={NumberField}
                                        label={"Uttagsavgift"}
                                        value={state.fields.withdrawal_fee}
                                        valid={
                                            (state.fields.withdrawal_fee.length > 0 && state.fields.withdrawal_fee >= 0 && state.fields.withdrawal_fee <= 100)
                                                ? true : ""
                                        }
                                        onChange={this._onFieldChange}
                                        onBlur={this._onFieldBlur}
                                        required
                                        unit={"%"}
                                    />
                                </div>
                            )}

                            <h3 style={{marginTop: "30px", marginBottom: "0"}}>Övrigt</h3>

                            {state.fields.selected_type.options[0].checked && (
                                <p style={{margin: "10px 0"}}>
                                    Beskriv bakgrunden till avslutet och vad som diskuterats i mötet. Minst 220 tecken måste fyllas i.
                                </p>
                            )}

                            {state.fields.selected_type.options[1].checked && (
                                <p style={{marginTop: "30px"}}>
                                    Beskriv bakgrunden till uttaget och vad som diskuterats i mötet. Minst 220 tecken måste fyllas i.
                                </p>
                            )}

                            <EditableField
                                name="meeting_notes"
                                Component={TextView}
                                label={`${700 - state.fields.meeting_notes.length} tecken kvar`}
                                value={state.fields.meeting_notes}
                                maxLength={700}
                                disableEnterKey={true}
                                valid={
                                    state.fields.meeting_notes.length > 0
                                        ? (state.fields.meeting_notes.length >= 220 && state.fields.meeting_notes.length <= 700)
                                        : null
                                }
                                resize="vertical"
                                onChange={this._onFieldChange}
                                onBlur={this._onFieldBlur}
                            />

                            <p style={{margin: "40px 0 10px 0"}}>
                                Beskriv övergripande kundupplevelse och kundnöjdhet. Minst 220 tecken måste fyllas i.
                            </p>

                            <EditableField
                                name="customer_experience"
                                Component={TextView}
                                label={`${700 - state.fields.customer_experience.length} tecken kvar`}
                                value={state.fields.customer_experience}
                                maxLength={700}
                                disableEnterKey={true}
                                valid={
                                    state.fields.customer_experience.length > 0
                                        ? (state.fields.customer_experience.length >= 220 && state.fields.customer_experience.length <= 700)
                                        : null
                                }
                                resize="vertical"
                                onChange={this._onFieldChange}
                                onBlur={this._onFieldBlur}
                            />

                            <OptionsList
                                type="radio"
                                orientation="horizontal"
                                description={"Rådgivningens utförande"}
                                name="radio_meeting_form"
                                options={state.fields.radio_meeting_form.options}
                                onChange={this._onOptionsListChange}
                                style={{marginTop: "20px"}}
                            />

                            <p style={{fontWeight: "bold", margin: "20px 0 5px 0"}}>
                                Datum för personligt möte:
                            </p>

                            <div style={{width: "200px"}}>
                                <EditableField
                                    name="meeting_date"
                                    Component={TextField}
                                    label={"Ange datum"}
                                    value={state.fields.meeting_date}
                                    valid={
                                        (state.fields.meeting_date)
                                            ? state.fields.meeting_date.length > 0 : ""
                                    }
                                    onChange={this._onFieldChange}
                                    onBlur={this._onFieldBlur}
                                    required
                                />
                            </div>
                        </React.Fragment>
                    )}
                </div>
            </div>
        );
    }

    _fieldValidator = (name, value) =>
    {
        return value.length > 0;
    };

    _onFieldChange = (name, value) =>
    {
        if (name === 'other_text' && value.length > 300)
        {
            value = value.substring(0, 300);
        }

        if (name === 'customer_withdrawal_reason' && value.length > 220)
        {
            value = value.substring(0, 220);
        }

        CobHelpers.onViewFieldChange.call(this, name, value, false, () =>
            fulfillmentCheck(this.props, this.state)
        );
    };

    _onFieldBlur = (name) =>
    {
        CobHelpers.onViewFieldBlur.call(this, name);
    };

    _onOptionsListChange = ({type, name}, option, index) =>
    {
        const newOptions = [...this.state.fields[name].options].map((o, i) =>
        {
            if (i === index)
            {
                return option;
            }
            else
            {
                return {...o, checked: type === "radio" ? false : o.checked};
            }
        });

        this.setState({
            fields: {
                ...this.state.fields,
                [name]: {
                    options: newOptions
                }
            }
        }, () => fulfillmentCheck(this.props, this.state));
    };
}


// PRIVATE FUNCTIONS
function _getFields()
{
    return [
        "customer_withdrawal_reason_option",
        "customer_withdrawal_reason_kapitalbehov",
        "customer_withdrawal_reason",
        "customer_account_number",
        "customer_placement_name",
        "move_all_account",
        "move_some_account",
        "move_some_amount",
        "withdraw_some_amount",
        "customer_withdrawal_reason_institut",
        "withdrawal_fee",
        "other_text",
        "meeting_notes",
        "meeting_date",
        "customer_experience",
        "radio_action",
        "radio_action_withdraw"
    ];
}

function _getInitialState()
{
    return {
        accountsLoading: true,
        fields: {
            meeting_notes: "",
            customer_experience: "",
            customer_withdrawal_reason_option: "",
            customer_withdrawal_reason_kapitalbehov: "",
            customer_withdrawal_reason: "",
            customer_account_number: "",
            customer_account_other_number: "",
            customer_account_other_placement: "",
            customer_withdrawal_reason_institut: "",
            customer_placement_name: "",
            move_all_account: "",
            move_some_account: "",
            move_some_amount: "",
            withdraw_some_amount: "",
            meeting_date: "",
            withdrawal_fee: "",
            other_text: "",
            accounts: {
                options: []
            },
            has_withdrawal_fee: {
                options: [
                    {
                        value: "no",
                        checked: false,
                        label: "Nej"
                    },
                    {
                        value: "yes",
                        checked: false,
                        label: "Ja"
                    }
                ]
            },
            selected_type: {
                options: [
                    {
                        value: "uppsagning",
                        checked: this.props.session.appKey && this.props.session.appKey === "termination_full",
                        label: "Avslut av förvaltning"
                    },
                    {
                        value: "partiell_uppsagning",
                        checked: this.props.session.appKey && this.props.session.appKey === "termination_partial",
                        label: "Uttag från förvaltning"
                    }
                ]
            },
            radio_meeting_form: {
                options: [
                    {
                        value: "m",
                        checked: false,
                        label: "Fysiskt möte"
                    },
                    {
                        value: "v",
                        checked: false,
                        label: "Videomöte"
                    }
                ]
            },
            radio_action: {
                options: [
                    {
                        value: "a",
                        checked: false,
                        label: "Jag vill att samtliga innehav på angiven depå/ISK avyttras och betalas ut till mitt föranmälda konto. Depå/ISK avslutas."
                    },
                    {
                        value: "m",
                        checked: false,
                        label: "Jag vill att samtliga innehav på angiven depå/ISK avyttras och att likviden därefter flyttas till annan depå hos Fair Investments."
                    }
                ]
            },
            radio_action_withdraw: {
                options: [
                    {
                        value: "x",
                        checked: false,
                        label: "Jag vill ta ut ett bestämt belopp och att likviden därefter flyttas till annan depå hos Fair Investments."
                    },
                    {
                        value: "w",
                        checked: false,
                        label: "Jag vill ta ut ett bestämt belopp och att det betalas ut till mitt föranmälda konto."
                    }
                ]
            }
        }
    };
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Fair/Withdrawal/Withdrawal.js